import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/netzo-logo-light.svg")